export default {
    state: {
        adjustment_id: null,
        errors: {},
        categories: [],
        form: {
            code: '',
            date: null,
            type: '',
            facility_id: '',
            store_id: '',
            item_id: '',
            notes: '',
        },
        meta: {
            adjustment_id: null,
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'code', sortable: true},
                {key: 'date', label: 'Date', sortable: true},
                {key: 'type', label: 'Type', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'store', label: 'Store', tdClass: 'text-muted'},
                {key: 'item', label: 'Item', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
    },

    getters: {
        getAdjustmentMeta: state => state.meta,

        getAdjustmentTableFields: state => state.table.fields,

        getAdjustmentForm: state => state.form,

        getAdjustmentErrors: state => state.errors,
    },

    mutations: {
        resetAdjustmentsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setAdjustments: (state, payload) => {
            state.categories = payload;
        },

        setAdjustmentsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setAdjustmentForm: state => {
            state.form = {
                code: '',
                date: null,
                type: '',
                facility_id: '',
                store_id: '',
                item_id: '',
                notes: '',
            };

            state.errors = {};
        },

        setAdjustmentErrors: (state, payload) => {
            state.errors = payload;
        },
    },

    actions: {
        fetchAdjustments: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const adjustment = {
                "data": [
                    {
                        "adjustment_id": 1,
                        "label": "Adjustment1",
                        "data": {
                            "type": "Adjustment",
                            "attributes": {
                                "code": "PRU000001",
                                "date": "12-12-12",
                                "type": "damage",
                                "facility": "NB-001 - Cedar Harbor Residence [V-IR] [I-DR]",
                                "store": "1",
                                "item": "i-phone",
                            }
                        },
                        "links": {"self": "adjustment\/1"}
                    },
                    {
                        "adjustment_id": 2,
                        "label": "Adjustment2",
                        "data": {
                            "type": "Adjustment",
                            "attributes": {
                                "code": "PRU000002",
                                "date": "17-02-11",
                                "type": "adjustment",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "u W u",
                                "item": "him-phone",
                            }
                        },
                        "links": {"self": "adjustment\/2"}
                    },
                    {
                        "adjustment_id": 3,
                        "label": "Adjustment3",
                        "data": {
                            "type": "Adjustment",
                            "attributes": {
                                "code": "PRU000003",
                                "date": "26-12-12",
                                "type": "expired",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "1",
                                "item": "nokia-3310",
                            }
                        },
                        "links": {"self": "adjustment\/3"}
                    },
                ],
                "links": {
                    "self": "\/adjustment",
                    "first": "http:\/\/pilot.test\/api\/inventory\/adjustments\/adjustment?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/adjustments\/adjustment?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/adjustments\/adjustment?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/adjustments\/adjustment",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setAdjustments', adjustment);

                commit('setAdjustmentsMeta', adjustment.meta);

                resolve(adjustment);
            });
        },

        fetchEditAdjustment: ({state, commit}, adjustment_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + adjustment_id + '/edit')
                    .then(response => {
                        state.adjustment_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitAdjustment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setAdjustmentErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateAdjustment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.adjustment_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setAdjustmentErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteAdjustment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.adjustment_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

    }
}
